import React from 'react';
import { InputProps } from '../../../types';
import { getInputStyles } from './styles';

interface StringInputProps extends InputProps<string> {
  type?: 'text' | 'email';
}

export const StringInput: React.FC<StringInputProps> = ({ 
  value, 
  onChange, 
  readOnly, 
  placeholder, 
  hasError, 
  isOverridden,
  type = 'text'
}) => {
  return (
    <input
      type={type}
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={readOnly}
      className={getInputStyles(readOnly, hasError, isOverridden)}
      placeholder={placeholder}
    />
  );
};
